module.exports = __webpack_public_path__ + "img/softgrove-3.9392d04c.jpeg";